import ExciseStratum from './ExciseStratum'
export default class LuExciseProjectionType {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //Description is required
      Description: '',
      //IsActive is required
      IsActive: false,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.Description = obj.Description
    this.IsActive = obj.IsActive
    this.ExciseStratum = []
    if (obj.ExciseStratum) {
      obj.ExciseStratum.forEach((item) => {
        this.ExciseStratum.push(new ExciseStratum(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.ExciseStratum = []
    if (this.ExciseStratum) {
      this.ExciseStratum.forEach((item) => {
        obj.ExciseStratum.push(item.removeRelated())
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.ExciseStratum = null
    return obj
  }
}
